import MenuCard from 'components/MenuCard/MenuCard.component';
import colors from 'style-utils/colors';
import media from 'style-utils/media-queries';
import { Flex } from 'style/flexbox.style';
import styled from 'styled-components';
import { cssTransitionClassNames } from '../SlideInMenu.config';

export const NavbarWrapper = styled.nav`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin: 0;
  overflow: hidden;
  color: ${colors.blackTwelve};
  z-index: 50;
  height: 50px;
  padding: 0 0 0 31px;
  position: fixed;
  top: 0;
  left: 0;
  box-shadow: 0 2px 10px 0 rgba(0000.04);
`;

export const MenuTabsWrapper = styled(NavbarWrapper)`
  position: static;
  box-shadow: unset;
  flex: 0 0 auto;
  background: transparent;
`;

export const SecondaryLinksWrapper = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0 8px 0 0;
  flex: 0 1 auto;
  display: flex;
  height: 100%;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;

  & > * {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    flex: 0 1 auto;
  }
`;

export const CloseButton = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0 8px;
  cursor: pointer;
  height: 100%;
  outline: none;
  border: none;
  background: ${colors.transparent};
`;
CloseButton.defaultProps = {
  type: 'button',
  'aria-label': 'close',
  title: 'close',
};

export const SlideInMenuContentWrapper = styled(Flex)`
  width: 583px;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const TabContentGrid = styled.div.attrs`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 16px;
  column-gap: 16px;
  grid-row-gap: 20px;
  row-gap: 20px;
`;

export const ExpandedTabContentGrid = styled.div`
  ${media.ie11.all`
    display: flex;
    align-items: flex-start;

    & > * {
      flex: 0 0 34%;
      margin-bottom: 24px;
    }

    & > *:nth-child(odd) {
      margin-right: 2%;
    }
  `}

  display: grid;
  width: 100%;
  flex: 0 0 auto;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 16px;
  column-gap: 16px;
  grid-row-gap: 24px;
  row-gap: 24px;
  padding: 42px 56px 42px 32px;
  will-change: opacity;

  &.${cssTransitionClassNames}-enter {
    opacity: 1;
    transform: translate3d(-120%, 0, 0);
    pointer-events: none;
  }

  &.${cssTransitionClassNames}-exit {
    opacity: 1;
    pointer-events: none;
  }
  &.${cssTransitionClassNames}-enter-active {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  &.${cssTransitionClassNames}-exit-active {
    opacity: 0;
  }

  &.${cssTransitionClassNames}-enter-active,
    &.${cssTransitionClassNames}-exit-active {
    transition:
      opacity 200ms ease-in,
      transform 200ms ease-in;
    /* Perfomance optimization, improves significantly transitions. */
    pointer-events: none;
  }

  &.${cssTransitionClassNames}-exit *,
  &.${cssTransitionClassNames}-enter *,
  &.${cssTransitionClassNames}-enter-active *,
  &.${cssTransitionClassNames}-exit-active * {
    /* Box shadows are expensive to animate/transition,
       we shut them down while transitioning. */
    box-shadow: none;
  }

  &[data-first-tab='true'].${cssTransitionClassNames}-enter-active {
    transition: none;
  }

  &.${cssTransitionClassNames}-enter-done,
    &.${cssTransitionClassNames}-exit-done {
    pointer-events: auto;
  }
`;

export const MenuCardOnRails = styled(MenuCard)`
  ${({ menuCard }): string => {
    if (menuCard?.smallCard) {
      return `
        grid-column: span 1;
      `;
    }

    return `
      grid-column: span 2;
    `;
  }}
`;
